import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { StyledTextField } from '../../../../Components/Generics.styled';
import { StyledButton } from '../../../../Components/Generics.styled';
const WebsiteURLContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: unset;
    border: 1px solid white;
`;

const WebsiteURL = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { websiteURL } = { ...teachDavieData };

    const [value, setValue] = useState('');

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, websiteURL: value }));
        handleNavButtonNext();
    };

    useEffect(() => {
        if (websiteURL !== '') {
            setValue(websiteURL);
        }
    }, [websiteURL]);

    return (
        <WebsiteURLContainer>
            <StyledTextField
                label="Enter your business website URL"
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                placeholder="Include http://"
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNext()}>Next</Btn>
            </NavButtonContainer>
        </WebsiteURLContainer>
    );
};

WebsiteURL.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

WebsiteURL.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default WebsiteURL;
